import { useDates } from "../../../dates/DatesContext";
import moment from "moment";
import useDSPSellerInfo from "./useDSPSellerInfo";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { DatasetsQueryFilter } from "../../../zodios/apiDefinitions/api/dsp/common";

export const useDSPGeoDatasetsQuery = (options?: {
  lineItemId?: string | number | null;
  orderId?: string | number | null;
  showAll?: boolean;
}) => {
  const { start, end, preStart, preEnd } = useDates();
  const { dspAdvertiser } = useDSPSellerInfo();

  const startDate = moment(start).format("YYYY-MM-DD");
  const endDate = moment(end).format("YYYY-MM-DD");
  const preStartDate = moment(preStart).format("YYYY-MM-DD");
  const preEndDate = moment(preEnd).format("YYYY-MM-DD");

  const filters: DatasetsQueryFilter[] = [
    { id: "date", value: { op: "gte", value: startDate } },
    { id: "date", value: { op: "lte", value: endDate } },
    { id: "date_prev", value: { op: "gte", value: preStartDate } },
    { id: "date_prev", value: { op: "lte", value: preEndDate } },
  ];

  if (dspAdvertiser?.id) {
    filters.push({ id: "dsp_seller_info_id", value: { op: "eq", value: dspAdvertiser.id } });
  }

  if (options?.lineItemId) {
    filters.push({ id: "line_item_id", value: { op: "eq", value: options.lineItemId } });
  }

  if (options?.orderId) {
    filters.push({ id: "order_id", value: { op: "eq", value: options.orderId } });
  }

  const body = {
    model: "dspgeo" as const,
    dimensions: "country,region",
    filters,
  };

  return useQuery({
    queryKey: ["dspGeoDatasets", startDate, endDate, preStartDate, preEndDate, filters],
    enabled: !!(dspAdvertiser?.id || options?.lineItemId || options?.orderId || options?.showAll),
    queryFn: async () => {
      return await apiClient.dspGeoDatasetsQuery(body);
    },
  });
};
